import React, { useState } from 'react';
import MeetingStoreView from 'Pages/dashboard/store/Payments/MeetingStoreView';
import CustomModal from 'components/Modal/CustomModal';
import './MeetingTakeaways.css';

const ViewMeetingTakeaways = ({ dataList }) => {
  const [show, setShow] = useState(false);
  const [questionId, setQuestionId] = useState(null);
  const handleClose = () => {
    setShow(false);
    setQuestionId(null);
  };
  return (
    <>
      <tr onClick={() => {
        setShow(true);
        setQuestionId(dataList?.id);
      }} className='meeting-takeaway-row'>
        <td>
          <div className="d-flex align-items-center">
            <div className="product-name">
              <span>{dataList?.question_text}</span>
            </div>
          </div>
        </td>
        <td>
          <div className="d-flex align-items-center">
            <div className="product-name">
              <span>{dataList?.count}</span>
            </div>
          </div>
        </td>
      </tr>
      <CustomModal
        showStatus={show}
        clickStatus={handleClose}
        buttonMessage="Close"
        closeStatus={handleClose}
        title={<div className="takeaway-header">Takeaway meetings</div>}
        message={<MeetingStoreView question_id={questionId} />}
        secondMessage="noClose"
        secondButton={false}
        modalClass="demo-details-modal"
        largeModal={true}
      />
    </>
  );
};

export default ViewMeetingTakeaways;
